//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import codeLogin from "./loginBox/codeLogin";
import pwdLogin from "./loginBox/pwdLogin";

import mainMenuTab from "@/components/mainMenuTab";
import divline from "@/components/ui/divline";

export default {
    components: { mainMenuTab, divline, codeLogin, pwdLogin },
    data() {
        return {
            type: "wx"
        };
    },
    methods: {
        // 微信登录
        wxAuth() {
            const opts = {
                refre: common.storage("referid") || "",
                redirect: encodeURIComponent(location.origin + "/loginWx")
            };
            const authLink = api.loginWx + "?" + common.urlMerge(opts);

            location.href = authLink;
        },

        // 如果已经登录
        isLogin() {
            const userInfo = common.storageJson("userInfo") || {};

            if (userInfo.user_id) {
                this.$router.push("/");
            }
        }
    },
    mounted() {},
    beforeMount() {
        this.isLogin();
    }
};



// WEBPACK FOOTER //
// ./src/views/login/login.vue